import '../../styles/aboutus.scss';
import AboutUs from "../Home/WhoWeAre"
import InnerHeader from "../InnerHeader"
import MissionValues from "./MissionValues"
import ValuePreposition from './ValuePreposition';
import Leadership from './Leadership';
import ScrollToAnchor from '../../ScrollToAnchor';
import { useTranslation } from "react-i18next";

export default function WhoWeAre(){
    const { t } = useTranslation();
    return(
        <>
            <ScrollToAnchor/>
            <InnerHeader breadcrumb={t(`aboutus.breadcrumb`)} title={t(`aboutus.title`)} />
            <AboutUs />
            {/* <MissionValues />
            <ValuePreposition /> */}
            <Leadership />
        </>
    )
}